<template>
    <div class="main-content">
        <img
            class="maintenance-img"
            :src="imcIconMaintenance"
            alt="">
        <p class="maintenance-desc">
            为了提高系统稳定性，本系统将于 <span class="u-colorful">{{ startDate }}</span> 至 <span class="u-colorful">{{ endDate }}</span> 进行维护升级，给您带来的不便敬请谅解，感谢您的理解与配合
        </p>
    </div>
</template>
<script>
import { imcIconMaintenance } from '@assets/js/res'

export default {
    name: 'under-maintenance',
    data: () => ({
        imcIconMaintenance: imcIconMaintenance,
        startDate: '2020-04-17 01:00',
        endDate: '2020-04-17 05:00',
    }),
}
</script>
<style lang="scss" scoped>
    .main-content{
        text-align: center;
        position: absolute;
        width: 600px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .maintenance-img{
            display: inline-block;
            width: 100%;
        }
        .maintenance-desc{
            margin-top: 20px;
            font-size: 16px;
            line-height: 28px;
            color: #333;
            font-weight: 500;
            .u-colorful{
                color: #FF7414;
            }
        }
    }
    .mobile, .ipad{
        .main-content{
            width: 90%;
            padding: 0 5%;
            .maintenance-desc{
                margin-top: 30px;
                font-size: 32px;
                line-height: 56px;
            }
        }

    }
</style>
